import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { euro, dt, PAYMENT_LABELS } from "@/lib/format";
import { PageHeader, Loading, StatCard, StatusBadge, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { CreditCard, Banknote, Wallet } from "lucide-react";

export default function Payments() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/payments").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loading />;

  const byMethod = { cash: 0, card: 0, other: 0 };
  items.forEach((p) => (byMethod[p.method] = (byMethod[p.method] || 0) + p.amount_cents));
  const total = items.reduce((s, p) => s + p.amount_cents, 0);

  return (
    <div>
      <PageHeader title="Pagamenti" subtitle="Incassi del servizio di cambio (distinti dalle cauzioni)" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Totale incassato" value={euro(total)} icon={Wallet} tone="ok" />
        <StatCard label="Contanti" value={euro(byMethod.cash)} icon={Banknote} />
        <StatCard label="Carta/POS" value={euro(byMethod.card)} icon={CreditCard} tone="cyan" />
        <StatCard label="Altro" value={euro(byMethod.other)} icon={Wallet} />
      </div>
      {items.length === 0 ? <EmptyState icon={CreditCard} title="Nessun pagamento" /> : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr>
              <th className="text-left px-4 py-3">Cliente</th><th className="text-left px-4 py-3">Data</th>
              <th className="text-left px-4 py-3">Metodo</th><th className="text-right px-4 py-3">Importo</th><th className="px-4 py-3"></th></tr></thead>
            <tbody className="divide-y">
              {items.map((p) => (
                <tr key={p.id} data-testid={`payment-${p.id}`}>
                  <td className="px-4 py-3 text-slate-600">{p.customer_name}</td>
                  <td className="px-4 py-3 text-slate-500">{dt(p.created_at)}</td>
                  <td className="px-4 py-3 text-slate-500">{PAYMENT_LABELS[p.method]}</td>
                  <td className="px-4 py-3 text-right font-bold">{euro(p.amount_cents)}</td>
                  <td className="px-4 py-3 text-right"><StatusBadge status={p.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
